
export const hillAfbAtGlance = [
  {
    label: "Total Economic Impact",
    value: 12.76,
    unit: "Billion USD",
    description: "Statewide economic contribution",
    color: "text-blue-800",
  },
  {
    label: "Annual Expenditures",
    value: 4.33,
    unit: "Billion USD",
    description: "Goods, services, construction & travel",
    color: "text-blue-600",
  },
  {
    label: "Annual Govt. Payroll",
    value: 2.12,
    unit: "Billion USD",
    description: "Military & civilian payroll",
    color: "text-blue-600",
  },
  {
    label: "Indirect Economic Impact",
    value: 6.31,
    unit: "Billion USD",
    description: "Secondary & induced impacts",
    color: "text-blue-600",
  },
  {
    label: "Total Direct Workforce",
    value: 26893,
    unit: "Jobs",
    description: "On-base employment",
  },
  {
    label: "Total Jobs Supported",
    value: 67046,
    unit: "Jobs",
    description: "Direct + indirect employment",
  },
];
export const workforceBreakdown = [
  { name: "Active Duty Personnel", value: 5608, unit: "Jobs" },
  { name: "Reserve & National Guard", value: 913, unit: "Jobs" },
  { name: "Government Civilians", value: 14151, unit: "Jobs" },
  { name: "Contract Civilians", value: 6221, unit: "Jobs" },
];
export const expenditureBreakdown = [
  {
    name: "Goods & Services",
    value: 4029.63,
    unit: "Million USD",
  },
  {
    name: "Construction Projects",
    value: 246.73,
    unit: "Million USD",
  },
  {
    name: "Local Purchases",
    value: 46.52,
    unit: "Million USD",
  },
  {
    name: "Travel Expenditures",
    value: 8.67,
    unit: "Million USD",
  },
];
export const economicImpactBreakdown = [
  {
    name: "Annual Govt. Payroll",
    value: 2.12,
    unit: "Billion USD",
  },
  {
    name: "Annual Expenditures",
    value: 4.33,
    unit: "Billion USD",
  },
  {
    name: "Indirect Economic Impact",
    value: 6.31,
    unit: "Billion USD",
  },
];


// export const hillAfbAtGlance = [
//   {
//     label: "Total Economic Impact",
//     value: "$12.76B",
//     subtext: "Annual statewide impact",
//   },
//   {
//     label: "Annual Expenditures",
//     value: "$4.33B",
//     subtext: "Goods, services & utilities",
//   },
//   {
//     label: "Total Workforce",
//     value: "26,893",
//     subtext: "Direct employment",
//   },
//   {
//     label: "Active Duty",
//     value: "5,608",
//     subtext: "Military personnel",
//   },
//   {
//     label: "Govt. Civilians",
//     value: "14,151",
//     subtext: "Federal civilian jobs",
//   },
//   {
//     label: "Contract Civilians",
//     value: "6,221",
//     subtext: "Private contractors",
//   },
// ];